<template>
  <div class="job-description">
    <h1 class="title">
      <span class="header" v-html="title" />
    </h1>
    <ul class="tags">
      <li class="tag" v-for="(item, index) in tags" :key="index">
        {{ item }}
        <span class="dot"></span>
      </li>
    </ul>
    <hr lis="divisor" />
    <ul class="benefit">
      <li v-for="(item, index) in benefits" :key="index">
        <img :src="getImgUrl(item.src)" :alt="item.text" />
        {{ item.text }}
      </li>
    </ul>
    <hr class="divisor" />
    <div class="job__description" v-html="content" />
  </div>
</template>

<script>
export default {
  created() {
    const { title, benefits, tags, content } = this.jobData;
    this.title = title;
    this.benefits = Object.values(benefits);
    this.tags = Object.values(tags);
    this.content = content;
  },
  props: {
    jobData: {
      type: Object,
    },
  },
  data() {
    return {
      title: '',
      tags: [],
      benefits: [],
      content: '',
    };
  },
  methods: {
    getImgUrl(url) {
      // TODO: study for a better solution
      // eslint-disable-next-line import/no-dynamic-require
      return require(`@/${url}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
.job-description {
  @media (min-width: $sm) {
    padding-top: 9.5rem;
  }
}
.title {
  margin-bottom: 2rem;
}
.tags {
  color: $color-secondary;
  opacity: 0.7;
  font-size: 1rem;
  @media (min-width: $sm) {
    width: 60%;
  }
  .tag {
    display: inline-block;
    &:nth-child(2) {
      display: none;
      @media (min-width: $sm) {
        display: initial;
      }
    }
    .dot {
      margin-left: 0.5rem;
      margin-right: 0.75rem;
      border-radius: 1;
      display: inline-block;
      vertical-align: middle;
      width: 2px;
      height: 2px;
      background: #faa9fb;
    }
    &:last-child {
      .dot {
        display: none;
      }
    }
  }
}

.benefit {
  li {
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    img {
      margin-right: 1rem;
    }
  }
}

.divisor {
  border: none;
  height: 1px;
  color: $color-secondary;
  background-color: $color-secondary;
  opacity: 0.3;
  margin: 2.5rem 0;
}
</style>
